import React, { useState } from "react";
import abuthr from "../assets/abuthr.png";
import about2 from "../assets/about2.jpg";
import Navbar from "../components/Navbar";
import GetInTouch from "../components/GetInTouch";
import TestimonialSlider from "../components/home/Testimonials";
import CtaSection from "../components/CtaSection";
import Footer from "../components/Footer";
import Benefits from "../components/Benefits";
import about3 from "../assets/about3.jpg";
const journeyItems = [
    {
        year: 2023  ,
        title: "Years of Journey",
        description:
            "From a contract-based concept to a full-fledged tech company, Veyonta Track has steadily evolved with purpose, innovation, and customer commitment.",
    },
    {
        year: 2024,
        title: "Humble Beginnings",
        description:
            "Veyonta Track began its journey in 2021 as a contract-based service provider, helping logistics partners with tailored fleet management and tracking solutions. These early engagements helped us build deep industry insights and trust.",
    },
    {
        year: 2025,
        title: "Expanding Capabilities",
        description:
            "As our client base grew, we expanded our core services and began building internal tools for live tracking, route planning, and operational analytics—enhancing the way businesses managed their vehicles.",
    },
    {
        year: 2026,
        title: "Tech-Driven Growth",
        description:
            "Our team focused on refining system architecture and integrating smart technologies like IoT sensors and GPS intelligence to deliver real-time fleet visibility and data accuracy.",
    },

];

const About = () => {
    const [activeJourney, setActiveJourney] = useState(0);
    const selectedJourney = journeyItems[activeJourney];

    return (
        <>
            {/* section 1 */}
            <section className="relative mx-2 overflow-hidden rounded-b-[24px] bg-black sm:mx-4 sm:rounded-b-[36px] lg:mx-6 lg:rounded-b-[42px]">
                <Navbar />

                <div
                    className="relative min-h-[520px] bg-cover bg-center sm:min-h-[620px] lg:min-h-[700px]"
                    style={{ backgroundImage: `url(${abuthr})` }}
                >
                    <div className="absolute inset-0 bg-black/65" />

                    <div className="relative z-10 flex min-h-[520px] items-center justify-center px-4 py-16 text-center sm:min-h-[620px] sm:px-5 sm:pt-24 lg:min-h-[700px]">
                        <div className="mx-auto max-w-[980px]">
                            <h1 className="text-3xl font-bold leading-tight text-white sm:text-5xl lg:text-[64px]">
                                About Us
                            </h1>

                            <div className="mx-auto mt-3 h-[3px] w-40 max-w-full rounded-full bg-[#ed860f] sm:w-[420px] lg:w-[520px]" />

                            <p className="mx-auto mt-6 max-w-[800px] text-xs leading-relaxed text-white/75 sm:mt-7 sm:text-base">
                               At Veyonta Track, we are committed to setting new benchmarks in fleet management and smart logistics solutions. We constantly strive to enhance our technology,
                                services, and standards—ensuring that every client experiences seamless control, reliable tracking, and meaningful analytics.
                            </p>

                            <div className="mx-auto mt-7 flex w-full max-w-sm flex-col items-center justify-center gap-3 sm:mt-8 sm:max-w-none sm:flex-row sm:gap-4">
                                <a
                                    href="/"
                                    className="inline-flex w-full items-center justify-center rounded-md bg-[#ed860f] px-6 py-3.5 text-sm font-medium text-white transition hover:bg-[#d9780d] sm:w-auto sm:min-w-[210px] sm:px-8 sm:py-4"
                                >
                                    Explore Solutions
                                </a>

                                <a
                                    href="/contact"
                                    className="inline-flex w-full items-center justify-center rounded-md border border-white px-6 py-3.5 text-sm font-medium text-white transition hover:bg-white hover:text-black sm:w-auto sm:min-w-[210px] sm:px-8 sm:py-4"
                                >
                                    Contact us
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* section2 */}
            <section className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 sm:py-20">
                {/* Header */}
                <div className="mb-10 text-center sm:mb-16">
                    <h2 className="mb-4 text-3xl font-bold sm:text-4xl">Our Mission</h2>
                    <p className="mx-auto max-w-5xl text-sm leading-relaxed text-gray-600 sm:text-base">
                        At Veyonta Track, our mission is to revolutionize the fleet and logistics industry through intelligent, data-driven technology. We strive to empower businesses with real-time insights, automation, and control—ensuring every vehicle, route, and operation works in perfect sync.

                        We are committed to building scalable solutions that reduce costs, improve safety, and boost operational efficiency.
                         Our goal is to become the trusted technology partner for businesses
                          looking to modernize and thrive in a fast-moving, digital-first world.                    </p>
                </div>

                {/* Main Content Container */}
                <div className="grid items-center gap-10 md:grid-cols-2 md:gap-12">

                    {/* Statistics Grid */}
                    <div className="grid grid-cols-2 gap-0 sm:gap-8">

                        {/* Stat 1 */}
                        <div className="border-b border-r border-gray-200 p-4 sm:pb-8 sm:pl-0 sm:pr-4 sm:pt-0">
                            <h3 className="mb-2 text-2xl font-bold text-orange-500 sm:text-4xl md:text-5xl">24/7</h3>
                            <p className="text-sm font-medium text-gray-700 sm:text-base">Technical Support</p>
                        </div>

                        {/* Stat 2 */}
                        <div className="border-b border-gray-200 p-4 sm:pb-8 sm:pl-4 sm:pt-0">
                            <h3 className="mb-2 break-words text-2xl font-bold text-orange-500 sm:text-4xl md:text-5xl">AIS-140</h3>
                            <p className="text-sm font-medium text-gray-700 sm:text-base">Certified Devices</p>
                        </div>

                        {/* Stat 3 */}
                        <div className="border-r border-gray-200 p-4 sm:pb-0 sm:pl-0 sm:pr-4 sm:pt-8">
                            <h3 className="mb-2 text-2xl font-bold text-orange-500 sm:text-4xl md:text-5xl">500+</h3>
                            <p className="text-sm font-medium text-gray-700 sm:text-base">Vehicles Connected</p>
                        </div>

                        {/* Stat 4 */}
                        <div className="p-4 sm:pb-0 sm:pl-4 sm:pt-8">
                            <h3 className="mb-2 text-2xl font-bold text-orange-500 sm:text-4xl md:text-5xl">99.9%</h3>
                            <p className="text-sm font-medium text-gray-700 sm:text-base">Platform Uptime</p>
                        </div>

                    </div>

                    {/* Image Section */}
                    <div className="h-[240px] w-full overflow-hidden rounded-2xl shadow-lg sm:h-[300px] md:h-[400px]">
                        <img
                            src={about2}
                            alt="Refueling truck"
                            className="w-full h-full object-cover"
                        />
                    </div>

                </div>
            </section>

            {/* section 3 */}
            <section className="overflow-hidden bg-[#fbfbfc] px-4 py-14 sm:px-6 sm:py-24">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-10 text-center animate-fade-in-up sm:mb-20">
                        <h2 className="mb-4 text-3xl font-bold text-slate-950 sm:text-4xl">Our Journey</h2>
                        <p className="mx-auto max-w-xl text-sm leading-relaxed text-slate-500 sm:text-base">
                            Our journey is driven by innovation, reliability, and a commitment
                            to helping businesses optimize fleet operations through technology.
                        </p>
                    </div>

                    <div className="grid grid-cols-3 gap-x-3 gap-y-8 animate-fade-in-up [animation-delay:200ms] sm:hidden">
                        {journeyItems.map((item, index) => {
                            const isActive = index === activeJourney;

                            return (
                                <button
                                    key={item.year}
                                    type="button"
                                    aria-pressed={isActive}
                                    onClick={() => setActiveJourney(index)}
                                    onFocus={() => setActiveJourney(index)}
                                    className="group flex min-w-0 flex-col items-center focus:outline-none"
                                >
                                    <span
                                        className={`mb-3 text-xs font-semibold transition-colors ${isActive
                                            ? "text-slate-700"
                                            : "text-slate-400 group-hover:text-orange-500"
                                            }`}
                                    >
                                        {item.year}
                                    </span>
                                    <span
                                        className={`relative z-10 h-7 w-7 rounded-full transition-all duration-300 ${isActive
                                            ? "scale-110 bg-orange-500 shadow-lg shadow-orange-200"
                                            : "bg-slate-300"
                                            }`}
                                    />
                                </button>
                            );
                        })}
                    </div>

                    <div className="hidden overflow-x-auto pb-4 animate-fade-in-up [animation-delay:200ms] sm:block">
                        <div className="relative min-w-[680px] pt-1 sm:min-w-[760px]">
                            <div className="absolute left-4 right-4 top-[72px] h-0.5 bg-slate-200 sm:top-[76px]" />

                            <div className="relative flex justify-between">
                                {journeyItems.map((item, index) => {
                                    const isActive = index === activeJourney;

                                    return (
                                        <button
                                            key={item.year}
                                            type="button"
                                            aria-pressed={isActive}
                                            onClick={() => setActiveJourney(index)}
                                            onMouseEnter={() => setActiveJourney(index)}
                                            onFocus={() => setActiveJourney(index)}
                                            className="group flex min-w-16 flex-col items-center focus:outline-none"
                                        >
                                            <span
                                                className={`mb-7 text-sm font-semibold transition-colors sm:mb-8 sm:text-base ${isActive
                                                    ? "text-slate-700"
                                                    : "text-slate-400 group-hover:text-orange-500"
                                                    }`}
                                            >
                                                {item.year}
                                            </span>
                                            <span
                                                className={`relative z-10 h-7 w-7 rounded-full transition-all duration-300 group-hover:scale-110 sm:h-8 sm:w-8 ${isActive
                                                    ? "scale-110 bg-orange-500 shadow-lg shadow-orange-200"
                                                    : "bg-slate-300"
                                                    }`}
                                            />
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div
                        key={selectedJourney.year}
                        className="mt-8 flex animate-fade-in-up flex-col items-center text-center sm:mt-14"
                    >
                        <span className="mb-3 block text-sm font-semibold text-orange-500">
                            {selectedJourney.year}
                        </span>
                        <h3 className="mb-2 text-xl font-bold text-slate-950 sm:text-2xl">
                            {selectedJourney.title}
                        </h3>
                        <p className="mx-auto mb-6 max-w-[600px] text-sm leading-relaxed text-slate-500 sm:text-base">
                            {selectedJourney.description}
                        </p>

                        <div className="h-2 w-48 overflow-hidden rounded-full bg-slate-200">
                            <div
                                className="h-full rounded-full bg-orange-400 transition-all duration-500 ease-out"
                                style={{
                                    width: `${((activeJourney + 1) / journeyItems.length) * 100}%`,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* section 4 */}
            <section className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 sm:py-20">
                {/* Header */}
                <div className="mb-10 text-center sm:mb-16 sm:text-left">
                    <h2 className="mb-4 text-3xl font-bold sm:text-4xl">Why Businesses Choose Veyonta Track</h2>
                    <p className="text-sm leading-relaxed text-gray-600 sm:text-base">
                        At Veyonta Track, we don’t just offer software—we deliver smart solutions that transform the way businesses manage their fleets. With a focus on efficiency, automation, and real-time visibility, we help you take control of every moving part in your logistics operation. Our commitment 
                        to innovation, reliability, and customer satisfaction sets us apart in the fleet management industry.
                    </p>
                </div>

                {/* Main Content */}
                <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-12">

                    {/* Left: Image */}
                    <div className="h-[260px] overflow-hidden rounded-2xl shadow-xl sm:h-[380px] sm:rounded-3xl lg:h-auto">
                        <img
                            src={about3}
                            alt="Fueling Station"
                            className="w-full h-full object-cover"
                        />
                    </div>

                    {/* Right: Points List */}
                    <div className="space-y-5 sm:space-y-8">

                        {/* Point 01 */}
                        <div className="flex items-center gap-4 border-b border-gray-200 pb-5 sm:gap-6 sm:pb-6">
                            <span className="text-4xl font-bold text-orange-400 opacity-60 sm:text-5xl">01</span>
                            <p className="text-sm font-medium text-gray-800 sm:text-lg">Real-Time Tracking & Smart Alerts</p>
                        </div>

                        {/* Point 02 */}
                        <div className="flex items-center gap-4 border-b border-gray-200 pb-5 sm:gap-6 sm:pb-6">
                            <span className="text-4xl font-bold text-orange-400 opacity-60 sm:text-5xl">02</span>
                            <p className="text-sm font-medium text-gray-800 sm:text-lg">Cost Optimization & Fuel Efficiency</p>
                        </div>

                        {/* Point 03 */}
                        <div className="flex items-center gap-4 border-b border-gray-200 pb-5 sm:gap-6 sm:pb-6">
                            <span className="text-4xl font-bold text-orange-400 opacity-60 sm:text-5xl">03</span>
                            <p className="text-sm font-medium text-gray-800 sm:text-lg">Scalable to Any Fleet Size</p>
                        </div>

                        {/* Point 04 */}
                        <div className="flex items-center gap-4 border-b border-gray-200 pb-5 sm:gap-6 sm:pb-6">
                            <span className="text-4xl font-bold text-orange-400 opacity-60 sm:text-5xl">04</span>
                            <p className="text-sm font-medium text-gray-800 sm:text-lg">Dedicated Support & Custom Solutions</p>
                        </div>

                    </div>

                </div>
            </section>

            {/* section 5 */}
            {/* <Benefits /> */}
            {/* section 6 */}


            {/* section 7 */}



            {/* section 8 */}


            <TestimonialSlider />
            <CtaSection />
            {/* <GetInTouch /> */}
            <Footer />
        </>
    );
};

export default About;
